{
  "selected_tickets": "Tickets sélectionnés",
  "diagnostic_file": "Diagnostic",
  "transparency": {
    "generate_file": "Générer un rapport",
    "modal": {
      "description": "La génération d’un rapport réel impactera vos données, cette action est irréversible. Souhaitez-vous réaliser un rapport Test ou Réel ?",
      "test": "Test",
      "real": "Réel"
    },
    "report_type": {
      "diagnostic": "Diagnostic",
      "test_report": "Rapport test",
      "real_report": "Rapport réel"
    },
    "period": {
      "to": "au"
    }
  }
}
